// Mobile chat is a reading surface: following the live tail is opt-in.
export function isMobileReadingChat(platform, isCoworkerChat) {
  return (platform === 'ios' || platform === 'android') && !isCoworkerChat;
}

export function shouldHoldChatScroll({ mobileReadingChat, isInferencing, hasAssistantResponse, followLive }) {
  // Cancel even delayed send/keyboard pins once the response starts. Explicit
  // jump-to-bottom remains available, as does positioning settled history.
  return mobileReadingChat && isInferencing && hasAssistantResponse && !followLive;
}
